import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ReceptionMembersBrowse from '../panels/ReceptionMembersBrowse';
import { MEMBER_TYPES } from '../receptionConstants';
import { ReceptionPageHeader } from '../ui';

export default function ReceptionMembersPage() {
  const { toast } = useOutletContext();
  return (
    <div className="recv-dash-pro recv-dash-pro--main">
      <ReceptionPageHeader
        badge="Annuaire"
        title="Adhérents"
        description="Recherche instantanée par matricule ou identité — filtre société et création de foyer intégrés."
      />
      <ReceptionMembersBrowse toast={toast} memberTypeLabels={MEMBER_TYPES} />
    </div>
  );
}
